import { Component, OnInit, Input } from '@angular/core';
import { m } from '@angular/core/src/render3';

@Component({
  selector: 'alg-autoricarica-text-request',
  templateUrl: './alg-autoricarica-text-request.component.html',
  styleUrls: ['./alg-autoricarica-text-request.component.scss']
})
export class AlgAutoricaricaTextRequestComponent implements OnInit {
  @Input() isActivationRequest: boolean;
  @Input() clientInfo: any;
  @Input() supplyCommodities: any;
  @Input() listTypeSupply: any;
  @Input() supplyGas: any;
  @Input() supplyLight: any;

  public activationFieldPrivacyParsed = [
    {
      label:
        'di essere socio (persona fisica) di Coop Alleanza 3.0 al momento della richiesta e di autorizzare le relative verifiche;',
    },

    {
      label:
        'di essere il titolare della/e fornitura/e di Accendi luce & gas Coop secondo quanto indicato nella presente richiesta e di autorizzare le relative verifiche;',
    },
    {
      label:
        'di conoscere ed accettare integralmente il contenuto del richiamato regolamento, così come di aver letto e compreso l’informativa privacy quale allegato inscindibile; ',
    },
    {
      label:
        'di essere consapevole e accettare che la qualifica di socio di Coop Alleanza 3.0, la titolarità della/e fornitura/e sopra indicate nonché la vigenza del relativo contratto di fornitura con Accendi luce & gas Coop sono condizioni essenziali per poter usufruire dello "Sconto automatico in bolletta";',
    },
    {
      label:
        'di essere consapevole e di accettare che i vantaggi economici ottenuti con lo “Sconto automatico in bolletta” cesseranno automaticamente al verificarsi di una o più delle seguenti ipotesi (i) perdita, per qualunque motivo, della qualifica di socio di Coop Alleanza 3.0 (ii)  cambio fornitore di energia elettrica e/o gas naturale (iii) cessazione o in corso di cessazione della/e fornitura/e sopra indicata/e;',
    },
    {
      label:
        'di essere consapevole che lo “Sconto automatico in bolletta” può essere in ogni caso disattivato in qualsiasi momento, senza necessità di addurre alcuna motivazione, recandosi presso un qualsiasi punto vendita di Coop Alleanza 3.0;',
    },
    {
      label:
        'di essere consapevole che in caso di fornitura in stato cessata o in corso di cessazione, qualunque sia la causa e/o ragione anche per cambio fornitore, lo Sconto non potrà essere riconosciuto e accreditato in fattura',
    },
    {
      label:
        'di essere consapevole e di accettare che la presente richiesta si intende presentata e sarà presa in carico esclusivamente a seguito di sottoscrizione con Firma Elettronica Semplice mediante apposizione di One Time Password (OTP) al dato di contatto telefonico fornito ad Accendi luce & gas Coop al momento della sottoscrizione del contratto o successivamente modificato in anagrafica. La richiesta di autoricarica, pervenuta tramite link inviato via sms, dovrà essere conclusa entro le ore 23:59 del giorno di ricezione del relativo messaggio in caso contrario il link non sarà più valido e non potrà essere inserito l’OTP ricevuto in differente e specifico sms. In tal senso, la Firma Elettronica Semplice mediante apposizione di One Time Password deve intendersi con la stessa validità ed efficacia della sottoscrizione apposta su supporto cartaceo.',
    },
  ];

  public deactivationFieldPrivacy = [
    {
      label:
        'per effetto e in considerazione della disattivazione dello “Sconto automatico in bolletta” non sarà più erogato alcuno sconto in bolletta, salvo eventuali ultime erogazioni in corso di elaborazione antecedenti alla data di disattivazione stessa;',
    },
    {
      label:
        'la presente richiesta di disattivazione si intende presentata e sarà presa in carico esclusivamente a seguito di sottoscrizione con Firma Elettronica Semplice mediante apposizione di One Time Password (OTP) inviata al dato di contatto telefonico fornito ad Accendi luce & gas Coop al momento della sottoscrizione del contratto o successivamente modificato in anagrafica. La richiesta di autoricarica, pervenuta tramite link inviato via sms, dovrà essere conclusa entro le ore 23:59 del giorno di ricezione del relativo  messaggio in caso contrario il link non sarà più valido e non potrà essere inserito l’OTP ricevuto in differente e specifico sms. In tal senso, la Firma Elettronica Semplice mediante apposizione di One Time Password deve intendersi con la stessa validità ed efficacia della sottoscrizione apposta su supporto cartaceo.',
    },
  ];

  public activationField = {
    label1: 'contraddistinto per:',
    label2: '€ Codice di fornitura energia elettrica',
    label3: '€ Codice di fornitura gas naturale',
    label4:
      'l\'attivazione della specifica premialità dello "Sconto automatico in bolletta", relativamente alla/e fornitura/e sopra indicata/e secondo i termini e le condizioni di cui al regolamento che disciplina l\'iniziativa "Catalogo Soci - Raccolta punti“, disponibile presso i punti vendita di Coop Alleanza 3.0. (quale soggetto promotore) oppure nel sito web ',
    label5: 'Il sottoscritto dichiara:',
    label6: 'https://www.coopalleanza3-0.it/',
    label7: `Ogni interessato deve sapere che la versione integrale dell’informativa privacy relativa al Catalogo Soci - Raccolta punti - Collazionamento a premi
    per l’anno in corso è disponibile insieme al contenuto del Regolamento Raccolta punti.`,
    label8: `Questa informativa ha come `,
    label9: `destinatari tutti i soci titolari della Carta SocioCoop `,
    label10: `e che in fase di `,
    label11: `fruizione punti `,
    label12: `i dati personali richiesti (indicati nel
    modulo) `,
    label13: `sono trattati dal Titolare al trattamento dei dati in qualità di soggetto promotore `,
    label14: `quale è COOP ALLEANZA 3.0 S. C., per consentire la
    verifica dei punti accumulati, anche presso gli altri Titolari in qualità di soggetti associati alla raccolta punti per l’anno corrente allo scopo di autorizzare l’utilizzo ed il ritiro del/i premio/i presenti in catalogo; `,
    label15: `sono previste comunicazioni dei dati personali `,
    label16: `per assicurare tra i vari Titolari del
    trattamento il rispetto del regolamento al fine di consentire le modalità di godimento dei premi.`,
    label17: `La base giuridica del trattamento `,
    label18: `è costituita dalla necessità di poter gestire la richiesta dell’interessato alla partecipazione all’operazione a premi per l’anno corrente, nonché dai relativi obblighi posti dalla normativa amministrativa e fiscale in fase di ritiro dei premi in catalogo; `,
    label19: `il trattamento dei dati `,
    label20: `non necessita di consenso in quanto gli stessi `,
    label21: `sono raccolti per adempiere `,
    label22: `agli obblighi di legge, `,
    label23: `contrattuali o precontrattuali.`,
    label24: `Per i dati trattati per finalità di gestione dell’operazione a premi `,
    label25: `il tempo di conservazione `,
    label26: `degli stessi `,
    label27: `è quello della durata della manifestazione a premi e comunque non oltre i termini necessari a conseguire gli scopi per cui sono stati raccolti `,
    label28: `secondo la normativa in materia I partecipanti `,
    label29: `sono liberi di fornire o meno i dati personali richiesti. `,
    label30: `Il loro mancato conferimento potrebbe impedire di partecipare con successo alla raccolta punti e di fruire dei premi.`,
    label31: `Ogni diritto di tutela`,
    label32: `è assicurato nelle modalità indicate nell’informativa completa , tenuto conto che l’Interesso deve sapere che :`,
    label33: `Il Titolare `,
    label34: `del trattamento dei dati è Alleanza Luce & Gas S.p.A., con sede legale in via Trattati Comunitari Europei 1957-2007, n. 13, 40127 Bologna (BO); `,
    label35: ` Il Responsabile della protezione dei dati `,
    label36: `(DPO) è contattabile a mezzo posta all'indirizzo : DataProtectionOfficer@alleanzalucegas.it e l'informativa privacy completa è disponibile al link: https://www.accendilucegas.it/privacy-policy/.`
  };



  public deactivationField = {
    label1:
      'la disattivazione dello "Sconto automatico in bolletta", relativamente alla/e fornitura/e',
    label2: 'Codice di fornitura energia elettrica:',
    label3: 'e Codice fornitura di gas naturale:',
    label4:
      'attivato secondo i termini e le condizioni di cui al regolamento che disciplina l\'iniziativa "Catalogo Soci - Raccolta punti“, disponibile presso i punti vendita di Coop Alleanza 3.0 (quale soggetto promotore) oppure nel sito web ',
    label5:
      'Fermo quanto sopra, il sottoscritto dichiara di essere consapevole e di accettare espressamente che:',
    label6:
      'L’interessato deve sapere che anche per questa fase del trattamento dei suoi dati:',
    label7:
      `L’interessato deve sapere che anche per questa fase del trattamento dei suoi dati:
      Il Titolare del trattamento è Alleanza Luce & Gas S.p.A., con sede legale in via Trattati Comunitari Europei 1957-2007, n. 13, 40127 Bologna (BO). Il Responsabile della protezione
      dei dati (DPO) è contattabile a mezzo posta all'indirizzo : DataProtectionOfficer@alleanzalucegas.it e l'informativa privacy completa è disponibile al link: https://www.accendilucegas.it/privacy-policy/.
      Ogni interessato deve sapere che la versione integrale dell’informativa privacy relativa al Catalogo Soci - Raccolta punti - Collazionamento a premi
      per l’anno in corso è disponibile insieme al contenuto del Regolamento Raccolta punti.`,
      label8: 'https://www.coopalleanza3-0.it/'
  };

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/components/molecules/alg-autoricarica-text-request/alg-autoricarica-text-request.component.ts